import React from 'react';
import { Link } from 'react-router-dom';

import { Box, Typography } from '@mui/material';
import { Theme, useTheme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

interface IAppFeatureTooltipContentProps {
  children: React.ReactNode;
  footerText: string;
  footerLinkText: string;
  footerLinkTo: string;
}

const useStyles = makeStyles<Theme>()((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
    maxWidth: 420,
  },
  footer: {
    borderTop: `1px solid ${theme.palette.border.main}`,
    paddingTop: theme.spacing(1),
  },
  footerText: {
    lineHeight: 1.375,
  },
  footerLink: {
    color: theme.palette.primary.main,
    textDecoration: 'underline',
    textUnderlineOffset: '2px',
  },
}));

export default function AppFeatureTooltipContent({
  children,
  footerText,
  footerLinkText,
  footerLinkTo,
}: IAppFeatureTooltipContentProps) {
  const theme = useTheme();
  const { classes } = useStyles(theme);

  return (
    <Box className={classes.root}>
      {children}
      <Box className={classes.footer}>
        <Typography variant="text-sm" className={classes.footerText}>
          {footerText}{' '}
          <Link to={footerLinkTo} className={classes.footerLink}>
            {footerLinkText}
          </Link>
        </Typography>
      </Box>
    </Box>
  );
}
